
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.028 6H7.972c-.532 0-1.002.203-1.409.61C6.188 6.986 6 7.44 6 7.972V26l3.99-3.99h14.038c.532 0 .986-.188 1.362-.564.407-.407.61-.892.61-1.455V7.97c0-.531-.203-.985-.61-1.36-.376-.408-.83-.611-1.362-.611zm-6.479 9.578L16 19.005l-1.55-3.427-3.473-1.597 3.474-1.55L16 9.006l1.55 3.427 3.473 1.55-3.474 1.596z"}})])
          )
        }
      }
    